var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('d-header',{attrs:{"fluid":""}},[_c('h1',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t("terms_and_conditions_title"))+"\n    ")])]),_vm._v(" "),_c('d-container',{attrs:{"fluid":""}},[_c('d-card',[_c('d-card-row',[_c('v-terms-and-conditions')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }